import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import a1 from "$/a1.svg";
import plusCircle from "$/plus-circle.svg";
import { LinkedOwnerBadge } from "@/LinkedOwnerBadge";
import type { Swiper as SwiperType } from "swiper";
// @ts-expect-error - Swiper CSS 모듈은 타입 정의가 없습니다
import "swiper/css";
// @ts-expect-error - Swiper Pagination CSS 모듈은 타입 정의가 없습니다
import "swiper/css/pagination";
// @ts-expect-error - Swiper Bundle CSS 모듈은 타입 정의가 없습니다
import "swiper/css/bundle";
import { useRef, useEffect } from "react";
import { useRouter } from "@tanstack/react-router";

export interface SwiperDataType {
  seq?: string;
  title: string;
  description: string;
  description1?: string;
  image: string;
  /** 연동(부보호자→주보호자) 펫이면 아바타에 링 + 주보호자 코너 배지 표시 */
  linked?: boolean;
  /** 연동 펫의 주보호자 이름(코너 배지 이니셜용) */
  linkedOwnerName?: string | null;
  /** 연동 펫의 주보호자 프로필 사진 URL(있으면 사진, 없으면 이니셜) */
  linkedOwnerImageUrl?: string | null;
}

export interface SwiperXBoxProps {
  data: SwiperDataType[];
  handleSelect?: (seq: string) => void;
  useAddPet?: boolean;
  onClick?: (seq: string) => void;
}

export const SwiperXBox = ({
  data,
  handleSelect,
  useAddPet = true,
  onClick,
}: SwiperXBoxProps) => {
  const { history } = useRouter();
  const swiperRef = useRef<SwiperType | null>(null);
  // 점(pagination)은 펫 수만큼만 생성 — '반려견 등록' 카드는 점에서 제외
  const dotCount = data.length;

  // 슬라이드 변경 시 bullet active 상태 직접 제어 (등록 카드에선 마지막 펫 점 유지)
  const handleSlideChange = (swiper: SwiperType) => {
    const bullets = document.querySelectorAll(".swiper-pagination-bullet");
    bullets.forEach((b) =>
      b.classList.remove("swiper-pagination-bullet-active")
    );
    const activeIdx = Math.min(swiper.realIndex, dotCount - 1);
    if (activeIdx >= 0 && bullets[activeIdx]) {
      bullets[activeIdx].classList.add("swiper-pagination-bullet-active");
    }
    if (handleSelect) {
      const currentSlide = data[swiper.realIndex];
      const slideKey = currentSlide?.seq; // 현재 슬라이드의 key 값
      handleSelect?.(slideKey?.toString() || "");
    }
  };

  useEffect(() => {
    // 초기 렌더링 시에도 active bullet 설정
    setTimeout(() => {
      if (swiperRef.current) handleSlideChange(swiperRef.current);
    }, 0);
  }, []);

  return (
    <div className="relative">
      <Swiper
        modules={[Pagination]}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        onSlideChange={handleSlideChange}
        pagination={{
          clickable: true,
          renderBullet: (index, className) => {
            if (index >= dotCount) return ""; // 펫 수만큼만 점 생성('등록' 카드 제외)
            return `<span class="${className} !bg-gray-200 !w-2 !h-2 !mx-1"></span>`;
          },
          bulletActiveClass: "swiper-pagination-bullet-active",
        }}
        spaceBetween={16}
        slidesPerView={1}
        className="relative [&_.swiper-pagination-bullet]:!transition-none [&_.swiper-pagination-bullet-active]:!bg-yellow [&_.swiper-slide_.border-yellow]:border-gray-200 [&_.swiper-slide-active_.border-gray-200]:!border-yellow"
        style={{ height: "145px", width: "340px" }}
      >
        {data.map((o: SwiperDataType, index: number) => (
          <SwiperSlide
            key={index}
            onClick={() => onClick?.(o.seq?.toString() || "")}
          >
            <div className="flex items-center bg-white border-2 border-gray-200 rounded-xl h-[114px]">
              <div className="relative mx-5 my-2 shrink-0">
                <img
                  src={o.image || a1}
                  alt="유치원 이미지"
                  className={`rounded-full w-[80px] h-[80px] bg-gray-50 ${
                    o.linked ? "ring-2 ring-[#1D9E75]" : ""
                  }`}
                />
                {o.linked && (
                  <LinkedOwnerBadge
                    name={o.linkedOwnerName}
                    imageUrl={o.linkedOwnerImageUrl}
                    size={26}
                  />
                )}
              </div>
              <div className="ml-2 text-left">
                <p
                  className={
                    "text-base font-bold " + `${o.description1 ? "" : "pb-2"}`
                  }
                >
                  {o.title}
                </p>
                <p className="text-sm text-[##666666]">{o.description}</p>
                {o.description1 && (
                  <p className="text-sm text-[##666666]">{o.description1}</p>
                )}
              </div>
            </div>
          </SwiperSlide>
        ))}
        {useAddPet && (
          <SwiperSlide key={null}>
            <div className="flex items-center bg-white border-2 border-gray-200 rounded-xl h-[114px]">
              <img
                src={a1}
                alt="유치원 이미지"
                className="mx-5 my-2 rounded-full w-[80px] h-[80px] bg-gray-50"
              />
              <div
                className="flex items-center text-left cursor-pointer"
                onClick={() => {
                  history.push("/customer/layout/user-pet-info-add");
                }}
              >
                <p className="text-base font-bold">귀여운 내새꾸 등록</p>
                <img src={plusCircle} alt="plusCircle" className="ml-1" />
              </div>
            </div>
          </SwiperSlide>
        )}
      </Swiper>
    </div>
  );
};
